module.exports = __webpack_public_path__ + "static/img/news7_3.a9f0e9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/news7_3.jpg
// module id = Fm+4
// module chunks = 0